declare namespace $ {

	type $mol_view__sub_bog_fragile_demo_collide_named1_1 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	export class $bog_fragile_demo_collide_named1 extends $bog_fragile_demo_collide_base1 {
		attach_icon( ): string
		Attach( ): $mol_view
		sub( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=named1.view.tree.d.ts.map